import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

// Connects to data-controller="slim-filter"
// This controller manages filtering of place groups based on sector and retailer selection
export default class extends Controller {
  static targets = ["placeGroups"]
  static values = {
    placeGroups: Array
  }

  connect() {
    this.originalPlaceGroups = this.placeGroupsValue || []
    this.initializePlaceGroupsSelect()
    this.setupEventListeners()
  }

  initializePlaceGroupsSelect() {
    if (this.hasPlaceGroupsTarget && !this.placeGroupsTarget.slimSelect) {
      this.placeGroupsTarget.slimSelect = new SlimSelect({
        select: this.placeGroupsTarget,
        settings: {
          showSearch: true,
          placeholder: 'Select Place Groups'
        }
      })
    }
  }

  setupEventListeners() {
    // Listen for sector changes
    const sectorSelect = this.element.querySelector('#campaign_sector_id')
    if (sectorSelect) {
      sectorSelect.addEventListener('change', this.handleSectorChange.bind(this))
    }

    // Listen for retailer changes
    const retailerSelect = this.element.querySelector('#campaign_retailer_id')
    if (retailerSelect) {
      retailerSelect.addEventListener('change', this.handleRetailerChange.bind(this))
    }
  }

  handleSectorChange(event) {
    const sectorId = event.target.value
    const retailerSelect = this.element.querySelector('#campaign_retailer_id')

    // Filter retailers by sector
    if (retailerSelect) {
      const allRetailers = JSON.parse(retailerSelect.dataset.retailers || '[]')
      const filteredRetailers = sectorId ?
        allRetailers.filter(retailer => retailer.sector_id == sectorId) :
        allRetailers

      this.updateRegularSelect(retailerSelect, filteredRetailers, 'id', 'name', 'Select Retailer')
    }

    // Reset retailer selection and filter place groups by sector only
    if (retailerSelect) {
      retailerSelect.value = ''
    }
    this.filterPlaceGroups(sectorId, null)
  }

  handleRetailerChange(event) {
    const retailerId = event.target.value
    const sectorSelect = this.element.querySelector('#campaign_sector_id')
    const sectorId = sectorSelect ? sectorSelect.value : null

    // Filter place groups by sector and retailer
    this.filterPlaceGroups(sectorId, retailerId)
  }

  filterPlaceGroups(sectorId, retailerId) {
    if (!this.hasPlaceGroupsTarget) return

    let filteredPlaceGroups = this.originalPlaceGroups

    if (sectorId) {
      filteredPlaceGroups = filteredPlaceGroups.filter(pg => pg.sector_id == sectorId)
    }

    if (retailerId) {
      filteredPlaceGroups = filteredPlaceGroups.filter(pg => pg.retailer_id == retailerId)
    }

    this.updateSlimSelect(this.placeGroupsTarget, filteredPlaceGroups, 'id', 'name')
  }

  updateRegularSelect(selectElement, data, valueKey, textKey, placeholder) {
    const currentValue = selectElement.value

    // Clear existing options except the blank option
    selectElement.innerHTML = `<option value="">${placeholder}</option>`

    // Add new options
    data.forEach(item => {
      const option = document.createElement('option')
      option.value = item[valueKey]
      option.textContent = item[textKey]

      // Restore selection if the option was previously selected and still exists
      if (currentValue && currentValue == item[valueKey]) {
        option.selected = true
      }

      selectElement.appendChild(option)
    })
  }

  updateSlimSelect(selectElement, data, valueKey, textKey) {
    if (!selectElement.slimSelect) return

    const currentValues = selectElement.slimSelect.getSelected()

    // Destroy and recreate the slim select with new options
    selectElement.slimSelect.destroy()

    // Clear existing options
    selectElement.innerHTML = ''

    // Add new options
    data.forEach(item => {
      const option = document.createElement('option')
      option.value = item[valueKey]
      option.textContent = item[textKey]

      // Restore selection if the option was previously selected
      if (currentValues.includes(item[valueKey].toString())) {
        option.selected = true
      }

      selectElement.appendChild(option)
    })

    // Reinitialize slim select
    selectElement.slimSelect = new SlimSelect({
      select: selectElement,
      settings: {
        showSearch: true,
        placeholder: 'Select Place Groups'
      }
    })
  }

  disconnect() {
    // Clean up slim select for place groups
    if (this.hasPlaceGroupsTarget && this.placeGroupsTarget.slimSelect) {
      this.placeGroupsTarget.slimSelect.destroy()
    }
  }
}
